module.exports = __webpack_public_path__ + "img/52_2.58117a5b.png";